import React, {Component} from 'react';
import './AccountDropdown.scss'
import AccountDropdownItem from "./AccountDropdownItem";
import auth from "../../user/services/Auth";
import {RouteConstants} from "../../route/services/RouteConstants";


class AccountDropdown extends Component {

  signOut = () => {
    if (this.props.dropDownItemSelected) {
      this.props.dropDownItemSelected();
    }
    auth.logout();
  };

  goToProfile = () => {
    if (this.props.dropDownItemSelected) {
      this.props.dropDownItemSelected();
    }
    this.props.history.push(RouteConstants.PROFILE);
  };

  render() {
    return (
        <div className="account-dropdown">
          <AccountDropdownItem label="navbar.account_settings" imageKey="la-gear" onClick={this.goToProfile}/>
          <AccountDropdownItem label="navbar.sign_out" imageKey="la-sign-out" onClick={this.signOut}/>
        </div>
    );
    /*  Removing these items for now as we don't have an implementation for these
      <AccountDropdownItem label="navbar.change_password" onClick={this.goToProfile}/>
    */
  }
}

export default AccountDropdown;